import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { API_PATHS } from '../constants/api-paths';
import { jsonHttpHeaders } from '../constants/http-headers';
import { BienImmobilier } from '../models/bien-immobilier.model';
import { Logement } from '../models/logement.model';

/**
 * Client HTTP des biens immobiliers ({@code /biens}).
 * Les unités d'un bien se créent aussi via {@link addLogement}.
 */
@Injectable({
  providedIn: 'root',
})
export class BienService {
  private readonly headers = jsonHttpHeaders();

  constructor(private readonly http: HttpClient) {}

  /** Liste tous les biens. */
  findAll(): Observable<BienImmobilier[]> {
    return this.http.get<BienImmobilier[]>(
      `${environment.apiUrl}${API_PATHS.biens}`
    );
  }

  /** Détail d'un bien (avec logements associés selon l'API). */
  findById(id: string): Observable<BienImmobilier> {
    return this.http.get<BienImmobilier>(
      `${environment.apiUrl}${API_PATHS.bien(id)}`
    );
  }

  /** Crée un bien. */
  create(bien: BienImmobilier): Observable<BienImmobilier> {
    return this.http.post<BienImmobilier>(
      `${environment.apiUrl}${API_PATHS.biens}`,
      bien,
      { headers: this.headers }
    );
  }

  /** Met à jour un bien existant. */
  update(bien: BienImmobilier): Observable<BienImmobilier> {
    const id = bien.idBienDto ?? '';
    return this.http.put<BienImmobilier>(
      `${environment.apiUrl}${API_PATHS.bien(id)}`,
      bien,
      { headers: this.headers }
    );
  }

  /** Supprime un bien. */
  delete(id: string): Observable<void> {
    return this.http.delete<void>(
      `${environment.apiUrl}${API_PATHS.bien(id)}`
    );
  }

  /** Ajoute une unité / logement sous un bien ({@code /biens/{id}/logements}). */
  addLogement(idBien: string, logement: Logement): Observable<Logement> {
    return this.http.post<Logement>(
      `${environment.apiUrl}${API_PATHS.bienLogements(idBien)}`,
      logement,
      { headers: this.headers }
    );
  }
}
